<template>
	<Transition name="popup">
		<div v-if="modelValue" :class="['popup', {'active': modelValue}]">
			<div class="popup-overlay" :class="{ 'is-active' : isTopPopup}"></div>
			<div :class="['popup-content', customClass, modalClass]" ref="contentRef" :style="contentStyle">
				<slot></slot>
			</div>
		</div>
	</Transition>
</template>

<script lang="ts" setup>
import { usePopup } from '@/composables/hconUsePopup'
import { onUnmounted, watch } from 'vue';

const {
	incrementPopupCount,
	decrementPopupCount,
  isTopMost,
	addPopupStack,
	removePopupStack
} = usePopup()

const props = defineProps({
	modelValue: {
		type: Boolean,
		required: true
	},
	modalClass: {
		type: String,
		required: false
	},
	customClass: {
		type: String,
		default: ''
	},
	showCloseButton: {
		type: Boolean,
		default: true
	},
	closeOnOverlay: {
		type: Boolean,
		default: true
	},
	contentStyle: {
		type: Object,
		default: () =>({})
	}
})

const emit = defineEmits(['update:modelValue', 'close', 'loginOpend', 'loginClosed'])
const contentRef = ref<HTMLElement | null>(null)

defineExpose({ contentRef })

// 팝업만의 고유 id
const instanceId = useId();

// 열림/닫힘 상태 감시하여 카운트 조절 및 로그인 팝업 컨텐츠 영역 높이값
watch(() => props.modelValue, async (newVal, oldVal) => {
	if (newVal) {
		incrementPopupCount()
		addPopupStack(instanceId) // 팝업 열리면 스택 추가

		await nextTick()
		emit('loginOpend')
	} else if (oldVal === true && !newVal) {
		decrementPopupCount()
    	removePopupStack(instanceId) // 팝업 닫히면 스택 제거
		emit('loginClosed')
	}
}, { immediate: true })

// 컴포넌트가 페이지 이동될 때 카운트 누수 방지
onUnmounted(() => {
	if (props.modelValue) {
		decrementPopupCount()
	}

  removePopupStack(instanceId)
})

// 가장 위에 있는 팝업 딤드만 보여줌
const isTopPopup = computed(() => {
	return isTopMost(instanceId)
});

</script>